import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import Rating from '@mui/material/Rating';
import {
  Button, Grid, Box, Typography, 
} from '@mui/material';
import ProgressBar from './ProgressBar';
import ReviewTabs from './ReviewTab';
import RatingProgress from './RatingProgress';

const ReviewSummary = ({ data }) => (
  <div className="w-full">
    <div className="w-full items-center gap-6 space-y-6 px-5 py-6 sm:flex sm:space-y-0 sm:px-8">
      <div className="flex w-full flex-col items-center space-y-1 sm:w-1/3">
        <div>
          <div className="flex flex-col items-center text-center">
            <div className="text-6xl font-semibold leading-none tracking-tight text-slate-900">
              {Math.round((data.rating_average) * 10) / 10}
            </div>
            <div className="mt-3">
              <Rating sx={{ fontSize: '18px', color: '#f59e0b' }} name="read-only" value={Math.round((data.rating_average) * 10) / 10} readOnly />
            </div>
            <div className="mt-1 text-sm text-slate-500">
              {data?.review_count}
              {' '}
              reviews
              {' '}
            </div>
          </div>
        </div>
       
      </div>

      <div className="w-full space-y-2 sm:w-1/3 sm:flex-1">
        <RatingProgress
          starValue="5" 
          starReviewValue={data.star_ratings.five_star}
          reviewCount={data.review_count}
        />
        <RatingProgress
          starValue="4" 
          starReviewValue={data.star_ratings.four_star}
          reviewCount={data.review_count}
        />
        <RatingProgress
          starValue="3" 
          starReviewValue={data.star_ratings.three_star}
          reviewCount={data.review_count}
        />
        <RatingProgress
          starValue="2" 
          starReviewValue={data.star_ratings.two_star}
          reviewCount={data.review_count}
        />
        <RatingProgress
          starValue="1" 
          starReviewValue={data.star_ratings.one_star}
          reviewCount={data.review_count}
        />

      </div>

      <div className="w-full sm:w-auto">
        <div className="flex justify-center">
          <button
            type="button" 
            className="w-full rounded-xl bg-slate-900 px-5 py-2.5 text-sm font-medium text-white shadow-sm transition duration-200 hover:-translate-y-0.5 hover:bg-slate-800 hover:shadow-md sm:w-auto"
          >
            Write a review
          </button>
        </div>
      </div>
    </div>             
  </div>
);

export default ReviewSummary;
